import Nav from "./navbar";
const Shopnow =() => {
    return (
        <div>
        <Nav/>
       <h1>THIS is users </h1></div>

    );
}
export default Shopnow;